import type { SubmitHandler } from 'react-hook-form';

import type { IContainerProps } from '~/components/utils/Container';
import type { IApiGetAppResponseBody } from '~/lib/api/modules/Apps';
import type { IUseCreateAppMutationValues } from '~/lib/api/modules/Apps/hooks/useCreateAppMutation';
import type { IAppFormValues } from './AppForm';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { useCreateAppMutation } from '~/lib/api/modules/Apps/hooks/useCreateAppMutation';
import { AppForm } from './AppForm';

export type ICreateAppFormProps = IContainerProps & {
  onSuccess?: (
    outputData: IApiGetAppResponseBody,
    inputValues: IUseCreateAppMutationValues,
  ) => void;
  cancelUrl?: string;
  organizationId?: string;
};

export const CreateAppForm: React.FC<ICreateAppFormProps> = (props) => {
  const { sx, onSuccess, cancelUrl, organizationId } = props;
  const createAppMutation = useCreateAppMutation();

  const handleSubmit: SubmitHandler<IAppFormValues> = (values) => {
    if (createAppMutation.isLoading) {
      return;
    }

    return createAppMutation.mutateAsync(
      {
        body: {
          name: values.name,
          iconId: values.icons?.[0]?.id,
          themeColorPrimary: values.themeColorPrimary,
          orgId: values.organizationId?.length
            ? values.organizationId
            : undefined,
        },
      },
      { onSuccess },
    );
  };

  return (
    <ContentBlock sx={sx}>
      <AppForm
        first
        mode="creation"
        onSubmit={handleSubmit}
        cancelUrl={cancelUrl}
        defaultValues={{ organizationId }}
      />
    </ContentBlock>
  );
};
